JST["quick-reorder__header"] = function anonymous(it
) {
var out='<header class="reorder__header text-center"> <h1 class="reorder__greeting m-0">'+( texts('greetUser@quickReorder') )+'</h1> <h2 class="reorder__subgreeting text-paragraph p-0"> '+( texts('productTitleInfo@quickReorder') )+' </h2></header>';return out;
};